import { useRef, useState } from "react";
import { FcAddDatabase, FcBusinessman, FcInspection } from "react-icons/fc";
import { BiErrorCircle } from "react-icons/bi";
import PrimaryButton from "../../../Components/PrimaryButton";
import InputLabel from "../../../Components/InputLabel";
import TextInput from "../../../Components/TextInput";
import InputError from "../../../Components/InputError";
import SelectInput from "../../../Components/SelectInput";
import Dropzone from "react-dropzone";
import { useForm } from '@inertiajs/react';

const CreateTenantForm = ({ status, domain_name }) => {

    const [step, setStep] = useState(1);

    const domainRef = useRef();

    const { data, setData, post, processing, errors, reset, progress } = useForm({
        tenant: '',
        domain: '',
        type: '',
        logo: null,
        owner_first_name: '',
        owner_last_name: '',
        owner_username: '',
        owner_mobile: '',
        owner_email: '',
    });


    const handleLogoPreview = async (acceptedFiles) => {

        await acceptedFiles.map((file) => {
            URL.revokeObjectURL(file.preview);

            Object.assign(file, {
                preview: URL.createObjectURL(file),
            });
        });
    }


    const handleSubDomain = (e) => {
        setData('tenant', e.target.value.trim().split(" ").join(""));
        domainRef.current.value = e.target.value.trim().split(" ").join("");
    }

    const submit = (e) => {
        e.preventDefault();
        post(route('tenant.store'));
    };

    const items = [
        { name: 'Tenant Setup',  order: 1, icon: FcAddDatabase },
        { name: 'Owner Profile',  order: 2, icon: FcBusinessman },
        { name: 'Summary', order: 3, icon: FcInspection }
    ]

    const options = [
        { value: "Humans", label: "For Humans" },
        { value: "Animals", label: "For Animals" },
    ];

    const handleNext = () => {
        setStep(step + 1);

        if(step === 1) {
            if(data.domain.length == 0) {
                reset('domain');
                setData('domain', data.tenant.trim().split(" ").join(""));
            }
        }
    };

    const handleBack = () => {
        setStep(step - 1);
    };

  return (
    <div className="flex items-center justify-center">
        <div className=" w-full px-8">
        <div className="py-6 flex flex-wrap items-center justify-center gap-x-12">
            {items?.map((item) => (
                <div
                key={item?.order}
                className={`cursor-pointer shadow-lg relative md:mt-0 mt-4 py-6 xl:px-4 rounded w-60 flex justify-center items-center flex-col bg-slate-50 ${step === item?.order ? "border border-emerald-400" : "hover:opacity-70 hover:border hover:border-slate-400"}`}
                onClick={() => setStep(item?.order)}
                >
                    <div className="mb-6">
                        <item.icon className="h-12 w-auto" />
                    </div>
                    <div className="text-slate-800 dark:text-white text-2xl font-semibold text-center">
                        <h2>{item?.name}</h2>
                    </div>
                </div>
            ))}
        </div>

            <div className="xl:px-24">

                {Object.values(errors).length > 0 &&
                    <div className="px-5 py-4 bg-red-100 rounded-lg flex items-center justify-between mt-7">
                        <div className="flex items-center">
                            <div className="flex-shrink-0">
                                <BiErrorCircle className="h-12 w-12 text-red-500" />
                            </div>
                            <ul className="unlist">
                            {Object.values(errors)?.map((error, i) => (
                                <li key={i+1} className="my-2 text-base text-red-500 pl-3">
                                    {error}
                                </li>
                            ))}
                            </ul>
                        </div>
                    </div>
                }


                <form onSubmit={submit}>
                    {step === 1 && (
                        <div className="mt-16 lg:flex justify-between border-b border-slate-200 pb-12">
                            <div className="w-80">
                                <div className="flex items-center">
                                    <h1 className="text-xl font-medium pr-2 leading-5 text-slate-800">Tenant Setup</h1>
                                </div>
                                <p className="mt-4 text-sm leading-5 text-slate-600">The tenant setup is simple, fill up tenant name, Type and optionally subdomain, logo. We take care about the rest, The system will fire automated events to creating database, cache, storage, seeding all available permissions.</p>
                                <p className="mt-4 text-medium leading-5 text-slate-700">Subdomain will be the same as tenant name but you can override it if you preferred.</p>
                            </div>
                            <div>
                                <div className="md:flex items-center lg:ml-24 lg:mt-0 mt-4">
                                    <div className="md:w-64">
                                        <InputLabel className="text-sm leading-none text-slate-800" htmlFor="tenant" value="Tenant" />
                                        <TextInput
                                            id="tenant"
                                            type="text"
                                            name="tenant"
                                            value={(data.tenant).toLowerCase()}
                                            className="block w-full p-3 mt-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                            placeholder="Enter tenant name"
                                            autoComplete="off"
                                            isFocused={true}
                                            onChange={(e) => handleSubDomain(e)}
                                        />
                                        <InputError message={errors.tenant} className="mt-2" />
                                    </div>
                                    <div className="md:w-64 md:ml-12 md:mt-0 mt-4">
                                        <InputLabel className="text-sm leading-none text-slate-800" htmlFor="type" value="Type" />
                                        <SelectInput
                                         id="type"
                                         name="type"
                                         defaultValue={(data?.type).toLowerCase()}
                                         className={`block w-full p-3 mt-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300`}
                                         options={options}
                                         onChange={(e) => setData('type', e.target.value)}
                                        />
                                        <InputError message={errors.type} className="mt-2" />
                                    </div>
                                </div>

                                <div className="md:flex items-center lg:ml-24 mt-6">
                                    <div className="w-full">
                                        <InputLabel className="text-sm leading-none text-slate-800" htmlFor="domain" value="Domain" />
                                        <TextInput
                                            id="domain"
                                            type="text"
                                            ref={domainRef}
                                            isFocused={false}
                                            name="domain"
                                            value={(domainRef?.current?.value || data.domain).toLowerCase()}
                                            className="group inline-flex w-[46%] p-3 mt-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                            placeholder="Subdomain"
                                            autoComplete="off"
                                            onChange={(e) => setData('domain', e.target.value)}
                                        />
                                        <span className="inline-flex p-3 mt-3 pl-1 text-base md:text-lg font-medium">.{domain_name}</span>
                                        <InputError message={errors.domain} className="mt-2" />
                                    </div>
                                </div>

                                <div className="md:flex items-center lg:ml-24 mt-8">
                                    <div className="w-full">
                                        <Dropzone
                                            accept={{'image/*': ['.jpeg', '.png', '.jpg', '.svg']}}
                                            multiple={false}
                                            maxFiles={1}
                                            onDropAccepted={acceptedFiles => setData('logo', acceptedFiles[0])}
                                            onDrop={(acceptedFiles) => handleLogoPreview(acceptedFiles)}
                                        >
                                            {({getRootProps, getInputProps}) => (
                                                <section className='flex flex-1 flex-col items-center place-content-center px-6 py-8 border-2 border-dashed border-slate-400 bg-slate-200 rounded-md cursor-pointer'>
                                                    <div {...getRootProps()}>
                                                        <input {...getInputProps()} />
                                                        {progress ?
                                                        (
                                                            <div className="order-first bg-slate-400 rounded-sm">
                                                                <div className="bg-indigo-500 text-xs font-medium text-indigo-100 text-center p-0.5 leading-none rounded-md" width={progress.percentage}> {progress.percentage}%</div>
                                                            </div>
                                                        ):(
                                                            <p className='text-slate-500 font-semibold'>
                                                                Drag and drop tenant logo here, or click to select image
                                                            </p>
                                                        )}
                                                    </div>
                                                    <p className="mt-1 text-red-600">
                                                        {errors.logo}
                                                    </p>
                                                </section>
                                            )}

                                        </Dropzone>

                                    </div>
                                </div>

                                {data?.logo && (
                                    <div className="md:flex items-center lg:ml-24 mt-8">
                                        <div className="p-0.5 rounded-md border border-indigo-500">
                                            <img className="h-20 w-auto object-cover bg-cover rounded" src={data?.logo?.preview} alt={data?.logo?.name} />
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    )}

                    {step === 2 && (
                        <div className="mt-16 lg:flex justify-between border-b border-slate-200 pb-16">
                            <div className="w-80">
                                <div className="flex items-center">
                                    <h1 className="text-xl font-medium pr-2 leading-5 text-slate-800">Owner Information</h1>
                                </div>
                                <p className="mt-4 text-sm leading-5 text-slate-600">Information about the tenant owner except the password. It will automatically generated however owner already has the ability to reset it.</p>
                                <p className="mt-4 text-medium leading-5 text-slate-700">Tenant owner will have the role <b>Owner</b> by default.</p>
                            </div>
                            <div className={`${data?.tenant?.length > 2 ? "blur-none" : "blur-sm"}`}>
                                <div className="md:flex items-center lg:ml-24 lg:mt-0 mt-4">
                                    <div className="md:w-64">
                                        <InputLabel className="text-sm leading-none text-slate-800" htmlFor="owner_first_name" value="Owner First Name" />
                                        <TextInput
                                            id="owner_first_name"
                                            type="text"
                                            name="owner_first_name"
                                            value={data.owner_first_name}
                                            className="block w-full p-3 mt-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                            placeholder="Enter owner first name"
                                            autoComplete="off"
                                            onChange={(e) => setData('owner_first_name', e.target.value)}
                                        />
                                        <InputError message={errors.owner_first_name} className="mt-2" />
                                    </div>

                                    <div className="md:w-64 md:ml-12 md:mt-0 mt-4">
                                        <InputLabel className="text-sm leading-none text-slate-800" htmlFor="owner_last_name" value="Owner Last Name" />
                                            <TextInput
                                                id="owner_last_name"
                                                type="text"
                                                name="owner_last_name"
                                                value={data.owner_last_name}
                                                className="block w-full p-3 mt-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                                placeholder="Enter owner last name"
                                                autoComplete="off"
                                                onChange={(e) => setData('owner_last_name', e.target.value)}
                                            />
                                        <InputError message={errors.owner_last_name} className="mt-2" />
                                    </div>
                                </div>
                                <div className="md:flex items-center lg:ml-24 mt-8">
                                    <div className="md:w-64">
                                        <InputLabel className="text-sm leading-none text-slate-800" htmlFor="owner_username" value="Owner Username" />
                                        <TextInput
                                            id="owner_username"
                                            type="text"
                                            name="owner_username"
                                            value={data.owner_username}
                                            className="block w-full p-3 mt-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                            placeholder="Enter owner username"
                                            autoComplete="off"
                                            onChange={(e) => setData('owner_username', e.target.value)}
                                        />
                                        <InputError message={errors.owner_username} className="mt-2" />
                                    </div>
                                    <div className="md:w-64 md:ml-12 md:mt-0 mt-4">
                                        <InputLabel className="text-sm leading-none text-slate-800" htmlFor="owner_mobile" value="Owner Mobile" />
                                        <TextInput
                                            id="owner_mobile"
                                            type="text"
                                            name="owner_mobile"
                                            value={data.owner_mobile}
                                            className="block w-full p-3 mt-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                            placeholder="Enter owner mobile"
                                            autoComplete="off"
                                            onChange={(e) => setData('owner_mobile', e.target.value)}
                                        />
                                        <InputError message={errors.owner_mobile} className="mt-2" />
                                    </div>
                                </div>
                                <div className="md:flex items-center lg:ml-24 mt-6">
                                    <div className="w-full">
                                        <InputLabel className="text-sm leading-none text-slate-800" htmlFor="owner_email" value="Owner Email" />
                                        <TextInput
                                            id="owner_email"
                                            type="email"
                                            name="owner_email"
                                            value={data.owner_email}
                                            className="block w-full p-3 mt-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                            placeholder="Enter owner email"
                                            autoComplete="off"
                                            onChange={(e) => setData('owner_email', e.target.value)}
                                        />
                                        <InputError message={errors.owner_email} className="mt-2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {step === 3 && (
                        <div className="mt-16 lg:flex justify-between border-b border-slate-200 pb-16 mb-4">
                            <div className="w-1/4">
                                <div className="flex items-center">
                                    <h1 className="text-xl font-medium pr-2 leading-5 text-slate-800">Summary</h1>
                                </div>
                                <p className="mt-4 text-sm leading-5 text-slate-600">Review tenant information carefully then save.</p>
                                <p className="mt-6 p-2 text-sm leading-6 font-semibold text-slate-700 bg-amber-200 rounded-sm border border-amber-400 shadow-md">Tenant will be created in less than a minute however you should wait 5 minutes before tring access tenant subdomain, to ensure that it's propagated throw DNS service.</p>
                            </div>

                            <div className="w-3/4">
                                <div className={`md:flex items-center lg:ml-24 lg:mt-0 mt-4 bg-stone-100 p-6 md:p-8 rounded-sm ${data?.tenant?.length > 2 ? "blur-none" : "blur-md"}`}>
                                    <div className="flex flex-col items-end w-full space-y-6">
                                        <div className="flex justify-between w-full items-center">
                                            <p className="text-lg leading-4 text-gray-600">Tenant Name:</p>
                                            <p className="text-lg font-semibold leading-4 text-gray-600">{data?.tenant}</p>
                                        </div>
                                        <div className="flex justify-between w-full items-center">
                                            <p className="text-lg leading-4 text-gray-600">Tenant Type:</p>
                                            <p className="text-lg font-semibold leading-4 text-gray-600">{data?.type}</p>
                                        </div>
                                        <div className="flex justify-between w-full items-center">
                                            <p className="text-lg leading-4 text-gray-600">Subdomain:</p>
                                            <p className="text-lg font-semibold leading-4 text-gray-600">{`${data?.domain }.${domain_name}`}</p>
                                        </div>
                                        <div className="flex justify-between w-full items-center">
                                            <p className="text-lg leading-4 text-gray-600">Owner Email:</p>
                                            <p className="text-lg font-semibold leading-4 text-gray-600">{data?.owner_email}</p>
                                        </div>
                                        <div className="mt-2 p-2 flex flex-col justify-between w-full items-center bg-amber-200 gap-4 rounded">
                                        <div className="flex justify-between w-full items-center">
                                            <p className="text-lg leading-4 text-gray-600">Owner Username:</p>
                                            <p className="text-lg font-semibold leading-4 text-gray-600">{data?.owner_username}</p>
                                        </div>
                                        <div className="flex justify-between w-full items-center">
                                            <p className="text-lg leading-4 text-gray-600">Owner Password:</p>
                                            <p className="text-lg font-semibold leading-4 text-gray-600">{`${data?.owner_first_name}_${data?.tenant}@MC2023`}</p>
                                        </div>
                                        </div>
                                        <div className="flex justify-between w-full items-center">
                                            <p className="text-lg leading-4 text-gray-600">Tenant Logo:</p>
                                            {data?.logo && (
                                                <div className="rounded-sm border border-indigo-500">
                                                    <img className="w-20 h-auto object-cover bg-cover rounded-sm" src={data?.logo?.preview} alt={data?.logo?.name} />
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="flex items-center justify-between mt-6">
                        {step < 3 && (
                            <button
                            type="button"
                            className="bg-emerald-400 px-6 py-1.5 rounded-lg text-white hover:bg-emerald-500"
                            onClick={handleNext}
                            >
                            Next
                            </button>
                        )}
                        {step === 3 && (
                            <PrimaryButton disabled={processing}>Save</PrimaryButton>
                        )}
                        {step > 1 && (
                            <button
                            type="button"
                            className="bg-slate-400 px-6 py-1.5 rounded-lg text-slate-700 hover:bg-slate-500"
                            onClick={handleBack}
                            >
                            Back
                            </button>
                        )}
                    </div>

                </form>

            </div>
        </div>
    </div>
  )
}

export default CreateTenantForm
